import {Injectable} from "@angular/core";
import {UserService} from "../Authorization/UserService";
import {BrandingService} from "../Branding/BrandingService";
import {MessagesService} from "../Messages/MessagesService";
import ISystemConfiguration = NPS.Common.Branding.ISystemConfiguration;
import {ScriptUtils} from "../Helpers/ScriptUtils";

interface IFreshWidget {
    init(redundantArg: any, config: IFreshWidgetConfig): void;
    update(config?: IFreshWidgetConfig): void;
    show(): void;
    close(): void;
    iframe(): HTMLIFrameElement;
    destory(): void;
}

interface IFreshWidgetConfig {
    queryString?: string;
    utf8?: string;
    widgetType?: string;
    buttonType?: string;
    buttonText?: string;
    buttonColor?: string;
    buttonBg?: string;
    alignment?: string;
    offset?: string;
    formHeight?: string;
    url?: string;
    widgetId?: number;
    backgroundImage?: string;
    assetUrl?: string;
    screenshot?: string;
    responsive?: string,
}

@Injectable()
export class FreshdeskWidgetService {
    private freshWidget: IFreshWidget;
    private systemConfiguration: ISystemConfiguration;

    constructor(private userService: UserService,
                private messagesService: MessagesService,
                private brandingService: BrandingService) {
        this.systemConfiguration = this.brandingService.getSystemConfiguration();
    }

    init() {
        if (this.systemConfiguration.FreshdeskWidgetEnabled) {
            this.loadFreshDesk();
        }
    }

    get isAvailable(): boolean {
        return this.systemConfiguration.FreshdeskWidgetEnabled && !!this.freshWidget;
    }

    show(): void {
        if (this.isAvailable) {
            this.freshWidget.show();
        } else {
            this.messagesService.add("Sorry, the support tool is currently not available", "", false);
        }
    }

    private loadFreshDesk(): void {
        ScriptUtils.load<IFreshWidget>(this.systemConfiguration.FreshdeskWidgetScriptUrl, "FreshWidget")
            .then((freshWidget: IFreshWidget) => {
                this.freshWidgetLoaded(freshWidget);
            })
            .catch((error: any) => {
                console.error("Failed to load FreshDesk.", error);
            });
    }

    private freshWidgetLoaded(freshWidget: IFreshWidget): void {
        this.freshWidget = freshWidget;

        if (this.freshWidget) {
            this.freshWidget.init("", {
                url: this.systemConfiguration.FreshdeskWidgetUrl,
                queryString: this.queryString,
                utf8: "✓",
                widgetType: "popup",
                buttonType: "text",
                buttonText: "Support",
                buttonColor: "white",
                buttonBg: "#002349",
                alignment: "2",
                offset: "70%",
                formHeight: "500px"
            });
        }
    }

    private get queryString(): string {
        var query = "widgetType=popup";
        query += "&disable[requester]=true";
        query += "&helpdesk_ticket[requester]=" + encodeURIComponent(this.userService.user.email);
        query += "&disable[product_id]=true";
        if (this.systemConfiguration.FreshdeskWidgetProductId) {
            query += "&helpdesk_ticket[product]=" + encodeURIComponent(this.systemConfiguration.FreshdeskWidgetProductId);
        }

        return query;
    }
}



// WEBPACK FOOTER //
// ./~/@nordpoolgroup/nps-angular-2-common/src/ApplicationBar/FreshdeskWidgetService.ts